import { lazy } from 'react';
import { adaptiveCenterModalOptions } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const CSClipsPageContent = lazy(() => import('./CSClipsPageContent'));

export const CSClipsPage = wrapLazyNavigatorScreen(
  CSClipsPageContent,
  adaptiveCenterModalOptions(),
);
